import { type Common } from '../common.js';
import {
  type AssistantConversationList,
  type ChatSessionPopulated,
  type GetChatSessionArgs,
} from '../models/assistant/chat.js';
import { SortOrder } from '../models/common.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/chat-sessions';
  }

  async getChatSessions(args: GetChatSessionArgs): Promise<AssistantConversationList> {
    const url = this.common.constructPath(`${this.baseEndpoint}/conversation`, args);
    return await this.common.getJSON(url);
  }

  async getChatSession(
    sessionId: string,
    args: {
      orderBy?: string;
      orderByDirection?: SortOrder;
    }
  ): Promise<ChatSessionPopulated> {
    const { orderBy = 'created', orderByDirection = SortOrder.Ascending } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${sessionId}`, {
      orderBy,
      orderByDirection,
    });
    return await this.common.getJSON(url);
  }
}
